export class ReservesIncomeRecordRequest {
  targetYear!:number
  incomeRecord!:number
}
